import { render, staticRenderFns } from "./MotorhomeDetailsCards.vue?vue&type=template&id=87ffc4e2&scoped=true"
import script from "./MotorhomeDetailsCards.vue?vue&type=script&lang=js"
export * from "./MotorhomeDetailsCards.vue?vue&type=script&lang=js"
import style0 from "./MotorhomeDetailsCards.vue?vue&type=style&index=0&id=87ffc4e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87ffc4e2",
  null
  
)

export default component.exports